// src/constants/service-types.js
export const ACTIONS = {
  SERVICE_TYPES_FETCH_START: 'SERVICE_TYPES_FETCH_START',
  SERVICE_TYPES_FETCH_SUCCESS: 'SERVICE_TYPES_FETCH_SUCCESS',
  SERVICE_TYPES_FETCH_FAILURE: 'SERVICE_TYPES_FETCH_FAILURE',
  SERVICE_TYPES_FETCH_RESET: 'SERVICE_TYPES_FETCH_RESET',

  SERVICE_TYPE_FETCH_START: 'SERVICE_TYPE_FETCH_START',
  SERVICE_TYPE_FETCH_SUCCESS: 'SERVICE_TYPE_FETCH_SUCCESS',
  SERVICE_TYPE_FETCH_FAILURE: 'SERVICE_TYPE_FETCH_FAILURE',
  SERVICE_TYPE_FETCH_RESET: 'SERVICE_TYPE_FETCH_RESET',

  SERVICE_TYPE_CREATE_START: 'SERVICE_TYPE_CREATE_START',
  SERVICE_TYPE_CREATE_SUCCESS: 'SERVICE_TYPE_CREATE_SUCCESS',
  SERVICE_TYPE_CREATE_FAILURE: 'SERVICE_TYPE_CREATE_FAILURE',
  SERVICE_TYPE_CREATE_RESET: 'SERVICE_TYPE_CREATE_RESET',

  SERVICE_TYPE_UPDATE_START: 'SERVICE_TYPE_UPDATE_START',
  SERVICE_TYPE_UPDATE_SUCCESS: 'SERVICE_TYPE_UPDATE_SUCCESS',
  SERVICE_TYPE_UPDATE_FAILURE: 'SERVICE_TYPE_UPDATE_FAILURE',
  SERVICE_TYPE_UPDATE_RESET: 'SERVICE_TYPE_UPDATE_RESET',

  SERVICE_TYPE_DELETE_START: 'SERVICE_TYPE_DELETE_START',
  SERVICE_TYPE_DELETE_SUCCESS: 'SERVICE_TYPE_DELETE_SUCCESS',
  SERVICE_TYPE_DELETE_FAILURE: 'SERVICE_TYPE_DELETE_FAILURE',
  SERVICE_TYPE_DELETE_RESET: 'SERVICE_TYPE_DELETE_RESET',
};
